import { getHostContext } from "../ui/hostContext";

export type OpenMode = "in-list" | "page" | "window";

export type DateFormat = "auto" | "iso" | "long" | "us" | "eu";

export type UiConfig = {
  defaultOpenMode: OpenMode;

  // Reader max height as a ratio of viewport height (0.0 - 1.0).
  // Applied to CSS var: --reader-max-height
  readerMaxViewportRatio: number;

  storageKeys: {
    theme: string;
    openMode: string;
    readerMaxViewportRatio: string;
    locale: string;
    timezone: string;
    dateFormat: string;
  };
};

function key(name: string): string {
  const p = getHostContext().storagePrefix;
  return `${p}_${name}`;
}

export const UI_CONFIG: UiConfig = {
  defaultOpenMode: "in-list",
  readerMaxViewportRatio: 0.8,
  storageKeys: {
    theme: key("theme"),
    openMode: key("open_mode"),
    readerMaxViewportRatio: key("reader_max_vpr"),
    locale: key("locale"),
    timezone: key("timezone"),
    dateFormat: key("date_format")
  }
};
